export function isDocumentAvailable() {
	return !!(typeof window !== 'undefined' && window.document && window.document.createElement)
}

export function getWindowHeight() {
	return window.innerHeight ||
		document.documentElement.clientHeight ||
		document.getElementsByTagName('body')[0].clientHeight;
}

export function getElementHeight(element) {
	return element ? element.clientHeight : 0
}

export function getElementY(element) {
	return element ? Math.round(element.getBoundingClientRect().top) : 0
}

export function getRelativePosition(element, windowHeight) {
  let y = getElementY(element)

	if (y > windowHeight) {
		y = windowHeight
	}

	if (y < -windowHeight) {
		y = -windowHeight
	}
	
	return y / windowHeight
}



// WEBPACK FOOTER //
// ./src/components/Parallax/util.js